import { ProductName } from "types/general";
import { ApiNotification } from "utils/api/notifications";
import { ApiUserProfile } from "utils/api/user";
import { getEarnedWageAccessOnboardingNotification } from "./earnedWageAccess";

export const getOnboardingStateNotificationUi = (props: {
  notification: ApiNotification;
  userProfile: ApiUserProfile;
}) => {
  const { notification } = props;

  switch (notification.params.product) {
    case ProductName.earnedWageAccess:
      return getEarnedWageAccessOnboardingNotification(props);
    case ProductName.taxRefundAdvance:
      // TAX_SEASON: Use or remove
      // return getTaxRefundAdvanceOnboardingNotification(props);
      return undefined;
    default:
      return undefined;
  }
};
